import { ListWithPagination } from '@/models/api/response/list'
import { Either } from 'fp-ts/lib/Either'

export interface Page<T> {
  /** ロード済のページか */
  readonly loaded: boolean
  /** 全体の何ページ目か */
  readonly number: number
  /** このページに含まれるアイテムのリスト */
  readonly list: T[]
  /** このページに含まれるアイテムの数 */
  readonly count: number
}

export abstract class BasePage<T> implements Page<T> {
  public abstract readonly loaded
  constructor (
    readonly number: number,
    readonly list: T[]
  ) {}

  get count(): number {
    return this.list.length
  }
}

export class IntentionallyLeftBlankPage<T> extends BasePage<T> {
  public readonly loaded = false

  constructor(readonly number: number) {
    super(number, [])
  }
}

export class LoadingBlankPage<T> extends BasePage<T> {
  public readonly loaded = false

  constructor(
    readonly number: number,
    readonly fetchPagePromise: Promise<Either<Error, ListWithPagination<T>>>
  ) {
    super(number, [])
  }
}

export class LoadedPage<T> extends BasePage<T> {
  public readonly loaded = true

  constructor(readonly number: number, readonly list: T[]) {
    super(number, list)
  }
}
